<template>
  <div>
    <Breadcrumbs
      :children="[
        {
          text: `Graficas`,
        },
      ]"
    />

    <div v-if="loading" class="text-center">
      <Loader />
    </div>
    <div v-else class="card ml-3">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 col-sm-12">
            <label>Cantidad de Visitas</label>
            <canvas id="myChart"></canvas>
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="text-black">Cantidad de Errores por pantalla</label>
            <canvas style="height: 100% !important" id="myChart2"></canvas>
          </div>
          <div class="col-md-6 col-sm-12">
            <label class="text-black">Cantidad de Errores por metodos</label>
            <canvas style="height: 100% !important" id="myChart3"></canvas>
          </div>
        </div>

        <!-- <div style="overflow-y: auto; max-height: 70vh; overflow-x: auto">
          <table class="table" id="list-supliers">
            <thead class="thead-light">
              <tr>
                <th>Nombre del servicio</th>
                <th>Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr v-show="loading && analytics.length === 0">
                <td class="text-center" colspan="8">
                  <Loader />
                </td>
              </tr>
              <tr v-for="service in analytics" :key="service.Id">
                <td>{{ service.Name || "N/A" }}</td>
                <td>{{ service.Amount }}</td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "../components/Loader";
import { AnalyticService } from "../../services/AnalyticService";
import Breadcrumbs from "../components/Breadcrumbs";

export default {
  name: "Analytics",
  components: {
    Loader,
    Breadcrumbs,
  },
  data: function () {
    return {
      analytics: [],
      crashlytics: [],
      distinctScreensAnalytics: [],
      distinctScreensCrashlytics: [],
      distinctMethodsCrashlytics: [],
      dataByScreensAnalytics: [],
      dataByScreensCrashlytics: [],
      dataByMeythodsCrashlytics: [],

      loading: false,
      paginationData: {
        currentPage: 1,
        totalOrders: 0,
        itemsPerPage: 7,
      },
      analyticService: new AnalyticService(),
    };
  },
  methods: {
    async getServices() {
      try {
        this.loading = true;

        const res = await this.analyticService.getAnalytics();
        const resCrashlytics = await this.analyticService.getCrashlytics();

        this.analytics = res.data;
        this.crashlytics = resCrashlytics.data;
        // Extract distinct screen values
        this.distinctScreensCrashlytics = [
          ...new Set(this.crashlytics.map((item) => item.Screen)),
        ];
        this.distinctScreensAnalytics = [
          ...new Set(this.analytics.map((item) => item.Screen)),
        ];
        this.distinctMethodsCrashlytics = [
          ...new Set(this.crashlytics.map((item) => item.MethodAction)),
        ];
        // Grouping the Amount by Screen
        const amountByAnalytic = this.analytics.reduce((acc, curr) => {
          if (!acc[curr.Screen]) {
            acc[curr.Screen] = 0;
          }
          acc[curr.Screen] += curr.Amount;
          return acc;
        }, {});

        // Transforming the grouped data into an array of objects
        const resultAnalytic = Object.keys(amountByAnalytic).map((screen) => ({
          Screen: screen,
          TotalAmount: amountByAnalytic[screen],
        }));

        const amountByCrash = this.crashlytics.reduce((acc, curr) => {
          if (!acc[curr.Screen]) {
            acc[curr.Screen] = 0;
          }
          acc[curr.Screen] += curr.Amount;
          return acc;
        }, {});

        //by methods
        const amountByMethods = this.crashlytics.reduce((acc, curr) => {
          if (!acc[curr.MethodAction]) {
            acc[curr.MethodAction] = 0;
          }
          acc[curr.MethodAction] += curr.Amount;
          return acc;
        }, {});

        // Transforming the grouped data into an array of objects
        const resultCrash = Object.keys(amountByCrash).map((screen) => ({
          Screen: screen,
          TotalAmount: amountByCrash[screen],
        }));

        // Transforming the grouped data into an array of objects by methods
        const resultCrashByMethods = Object.keys(amountByMethods).map(
          (methodAction) => ({
            MethodAction: methodAction,
            TotalAmount: amountByMethods[methodAction],
          })
        );

        //by methods crash
        this.dataByMeythodsCrashlytics = resultCrashByMethods
          .filter((item) => item.MethodAction) // Filtering to remove undefined or null Screen values
          .map((item) => item.TotalAmount);

        this.dataByScreensCrashlytics = resultCrash
          .filter((item) => item.Screen) // Filtering to remove undefined or null Screen values
          .map((item) => item.TotalAmount);

        this.dataByScreensAnalytics = resultAnalytic
          .filter((item) => item.Screen) // Filtering to remove undefined or null Screen values
          .map((item) => item.TotalAmount);

        // console.log("amount cra", amountByCrash);
        // console.log("crashlytics", this.crashlytics);
        // console.log("analytics", this.analytics);

        this.loading = false;
      } catch (error) {
        this.$helpers.message("Error", error.message, "error");

        this.loading = false;
      }
    },
    loadChart() {
      const ctx = document.getElementById("myChart");
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: this.distinctScreensAnalytics,
          datasets: [
            {
              label: "Cantidad de vista por pantalla",
              backgroundColor: ["rgba(34,186,131,255)", "rgba(59,138,165,255)"],
              borderColor: ["rgb(59,138,165,255)"],
              data: this.dataByScreensAnalytics,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
      const ctx2 = document.getElementById("myChart2");

      new Chart(ctx2, {
        type: "doughnut",
        data: {
          labels: this.distinctScreensCrashlytics,

          datasets: [
            {
              label: "Cantidad de errores por pantalla",
              backgroundColor: ["rgba(34,186,131,255)", "rgba(59,138,165,255)"],
              borderColor: ["rgb(59,138,165,255)"],
              data: this.dataByScreensCrashlytics,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });

      const ctx3 = document.getElementById("myChart3");

      new Chart(ctx3, {
        type: "doughnut",
        data: {
          labels: this.distinctMethodsCrashlytics,

          datasets: [
            {
              label: "Cantidad de errores por metodos",
              backgroundColor: ["rgba(34,186,131,255)", "rgba(59,138,165,255)"],
              borderColor: ["rgb(59,138,165,255)"],
              data: this.dataByMeythodsCrashlytics,
            },
          ],
        },
        options: {
          scales: {
            y: {
              beginAtZero: true,
            },
          },
        },
      });
    },
  },
  mounted: async function () {
    await this.getServices();
    this.loadChart();
  },
};
</script>
